import React from "react";
import { observer } from "mobx-react";

import { Event } from "@gp/models";
import { Tooltip } from "react-tooltip";
import { useTranslation } from "react-i18next";

export const AggregatedScore = observer(function AggregatedScore({
	event,
}: {
	event: Event;
}) {
	const { t } = useTranslation();

	if (!event.result?.aggregateScore) {
		return (
			<div className="offer__body__data offer__aggregate offer__aggregate--empty" />
		);
	}

	const tooltipId = `aggregate-${event.id}`;

	let tooltipMessage = "";

	if (event.isLive) {
		tooltipMessage = t("OFFER.TOOLTIP.AGGREGATE_SCORE.LIVE");
	} else {
		tooltipMessage = t("OFFER.TOOLTIP.AGGREGATE_SCORE.PREMATCH");
	}

	return (
		<div
			className="offer__body__data offer__aggregate"
			data-tooltip-id={tooltipId}
			data-tooltip-content={tooltipMessage}
			data-tooltip-position-strategy="fixed"
		>
			<div>({event.result?.aggregateScore?.home || 0})</div>
			<div>({event.result?.aggregateScore?.away || 0})</div>

			<Tooltip
				id={tooltipId}
				className="at-tooltipTeams react-tooltip--primary"
				place="left"
				offset={-2}
				closeOnResize={true}
			/>
		</div>
	);
});
